module.exports = __webpack_public_path__ + "static/meta-3e30b7970c5f05ac8f40f02dbaa33db0.png";